import '~/js/views/weddings/includes/stickyNav';
import 'slick-carousel';

const $resortSelect = $('#js-resort-select');
const inclusionsButton = document.querySelector('#extraButton a');

const resortSelectHandler = (event, data) => {
    if (data.item.value !== '') {
        inclusionsButton.setAttribute('href',`/en/weddings/inclusions/?rooms=${data.item.value}`);
    }
};

$resortSelect.selectmenu({
    appendTo: $resortSelect.parent(),
    change: resortSelectHandler
});

const $inclusionSlider = $('#inclusionWrap');
const inclusionSettings = {
    dots: true,
    arrows: false,
    appendDots: $('#inclusionWrap')
};
const $itinerarySlider = $('#itineraryWrap');
const itinerarySettings = {
    dots: true,
    arrows: false,
    appendDots: $('#itineraryWrap')
};

window.addEventListener('load', () => {
    if (window.innerWidth < 768) {
        $inclusionSlider.slick(inclusionSettings);
        $itinerarySlider.slick(itinerarySettings);
    }

    return false;
});

const debouncedSlider = _.debounce( () => {
    if (window.innerWidth > 768) {
        if ($inclusionSlider.hasClass('slick-initialized')) {
            $inclusionSlider.slick('unslick');
            $itinerarySlider.slick('unslick');
        }
    } else if (window.innerWidth < 768) {
        if (!$inclusionSlider.hasClass('slick-initialized')) {
            return $inclusionSlider.slick(inclusionSettings) && $itinerarySlider.slick(itinerarySettings);
        }

        return false;
    }

    return false;
}, 300);

window.addEventListener('resize', debouncedSlider);
